export default "__VITE_ASSET__6Thv_By0__"